import type { NameEntry } from './name-entry';

export function employeesShortNamesAndCurrentUserPronoun(
  employeesShortNames: NameEntry[],
  currentEmployeeUuid: string,
  currentUserPronoun: string,
): NameEntry[] {
  if (currentEmployeeUuid === undefined) {
    return employeesShortNames;
  }
  const result = employeesShortNames.filter(function (item) {
    return item.uuid !== currentEmployeeUuid;
  });
  const currentEmployee = employeesShortNames.filter(function (item) {
    return item.uuid === currentEmployeeUuid;
  })[0];
  result.push({
    uuid: currentEmployeeUuid,
    status: currentEmployee.status,
    name: currentUserPronoun,
    phone: '',
    email: '',
  });
  return result;
}
